// @core/api/endpoints/fiscalization/open_shift.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  OpenShiftRequest,
  OpenShiftResponse,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Open fiscal shift
 * Opens a new shift on a fiscal point. Only one shift can be open at a time. Shift must be closed within 24 hours.
 */
export async function OpenShift(
  fiscalPointId: string,
  data: OpenShiftRequest,
  options?: RequestOptions
): Promise<OpenShiftResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/fiscal-points/:fiscalPointId/shifts/open`;
  requestPath = requestPath.replace(':fiscalPointId', encodeURIComponent(fiscalPointId));
  const requestOptions = options;
  return client.post<OpenShiftResponse>(requestPath, data, requestOptions);
}
